import { Suspense, useEffect, useMemo, useState } from "react";
import CustomAccordion from "../../../../components/ui/materialui/customAccordion";
import Tabla from "../../../../components/ui/materialui/serverSideTable";
import TableHeader from "../../../../components/ui/materialui/tableHeader";
import MButton from "../../../../components/inputs/yup/materialui/mButton";
import { exportExcel } from "../../../../utils/exportExcel";
import { useDataFetch } from "../../../../hooks/useDataFetch2";
import { useValidadorAsientosContablesContext } from "../../../../context/validadorAsientosContablesContext";
import { useColumnResumenVisados } from "../utils/columnsResumenVisados";
import SummarizeTwoToneIcon from '@mui/icons-material/SummarizeTwoTone';
import { Grid2 } from "@mui/material";
import { useLoader } from "../../../../hooks/useLoader";
import { enviarLayoutGdi } from "../services/serviceValidadorAsientosContables";
import { useToast } from "../../../../hooks/useToast";
import ConfirmationModal from "../../../../components/ui/materialui/confirmationModal";
import { PermissionGuard } from "../../../../components/auth/ProtectedRoute";
import { TipoFuncionalidad } from "../../../../utils/enums";
import { getCurrentUsername } from '../../../../services/userRolesService';

const urlTabla = `siscred-api-contabilizacion/v1/peoplesoft/obtenerregistrosvisado`;

function ResumenVisadosComponent() {

    const { formFilters, reloadFlag, incrementReloadFlag } = useValidadorAsientosContablesContext();
    const { showLoader, hideLoader } = useLoader();
    const { addToast } = useToast();

    const params = useMemo(() => {
        if( formFilters?.fechaFin == null ) return;
        const p = new URLSearchParams();
        p.set("fechaDesde", formFilters!.fechaInicio!.toISOString().split("T")[0]);
        p.set("fechaHasta", formFilters!.fechaFin!.toISOString().split("T")[0]);
        p.set("codigoAccion", formFilters!.codigoAccion == 'Todas' ? '' : formFilters!.codigoAccion);
        p.set("numeroOperacion", formFilters!.numeroOperacion ? formFilters!.numeroOperacion : '');
        return p;
    }, [formFilters, reloadFlag]);

    const dataTable = useDataFetch(
        urlTabla,
        params,
        true,
    );

    const [ visados, setVisados ] = useState<any[]>([]);
    const [ idsToLayout, setIdsToLayout ] = useState<number[]>([]);
    const [modalConfirmacion, setModalConfirmacion] = useState({
        show: false,
        title: '',
        message: '',
        metodo: () => {},
    });

    const { COLUMNS } = useColumnResumenVisados({ controlTabla: dataTable, visados, setVisados, idsToLayout, setIdsToLayout });
    const columns = useMemo(() => COLUMNS, [dataTable]);

    const onEnviarLayout = async () => {
        showLoader();
        const resp = await enviarLayoutGdi(idsToLayout, getCurrentUsername())
        addToast({
            mostrar: true,
            titulo: resp.data?.ok ? 'Éxito' : 'Error',
            tipo: resp.data?.ok ? 'Success' : 'Danger',
            mensaje: resp.data?.mensaje,
        });
        incrementReloadFlag();
        hideLoader();
    };

    const modalConfirmEnvio = () => {
        setModalConfirmacion({
            show: true,
            title: 'Enviar Layout GDI',
            message: '¿Está seguro que desea Enviar Layout GDI para los registros seleccionados?',
            metodo: onEnviarLayout,
        });
    };

    useEffect(() => {
        if( reloadFlag > 0 ) dataTable.fetchData();
    }, [reloadFlag]);

    return (
        <CustomAccordion title={'Resumen visados'} expandedDefault>
            <Suspense>
                <ConfirmationModal
                    onHide={() =>
                        setModalConfirmacion({
                            ...modalConfirmacion,
                            show: false,
                        })
                    }
                    onConfirm={modalConfirmacion.metodo}
                    show={modalConfirmacion.show}
                    title={modalConfirmacion.title}
                    message={modalConfirmacion.message}
                />
                <Tabla
                    columns={columns}
                    control={dataTable}
                    url={urlTabla}
                    titulo={
                        <TableHeader
                            title=""
                            control={dataTable}
                            button={
                                <Grid2 container spacing={1} sx={{ justifyContent: "flex-end", textAlign: "right" }}>
                                    <MButton
                                        type="button"
                                        variant='contained'
                                        color='primary'
                                        disabled={idsToLayout.length ? false : true}
                                        onClick={modalConfirmEnvio}
                                    >
                                        Enviar Layout GDI
                                    </MButton>
                                </Grid2>
                            }
                            buttonExport={
                                <PermissionGuard permissions={[TipoFuncionalidad.Transversal_exportar]}>
                                <MButton
                                    type="button"
                                    variant="outlined"
                                    onClick={() => exportExcel(dataTable.data, columns, "resumenVisados")}
                                    startIcon={<SummarizeTwoToneIcon />}
                                >
                                    Exportar
                                </MButton>
                                </PermissionGuard>
                            }
                        />
                    }
                />
            </Suspense>
        </CustomAccordion>
    )
}

export default ResumenVisadosComponent;